import axios from "@/api/axios";
import _ from "lodash";
import qs from "qs";

// 피팅 리스트
const get_fittinglist = async (param, result) => {
  const token = sessionStorage.getItem("token") || null;

  const options = {
    method: "GET",
    url: process.env.VUE_APP_API_URL + "/fitting/fittinglist",
    //url: 'http://localhost/test.php',
    headers: { Authorization: "Bearer " + token },
    params: {
      searchtype: param.searchtype,
      searchname: param.searchname,
      pageno: param.pageno,
      pagesize: param.pagesize,
      findex: param.findex,
      goodstype: param.goodstype,
    },
  };
  try {
    await axios(options).then((response) => {
      if (response.data.code === 200) {
        result(true, response.data);
      } else {
        console.error(response.data.code, response.data.message);
        result(false, response.data);
      }
    });
  } catch (err) {
    console.error("set_memberswingopen", err);
    result(false, err);
  }
};

// 피팅 스윙 리스트
const get_fittingswinglist = async (fittingno, param, result) => {
  const token = sessionStorage.getItem("token") || null;
  const options = {
    method: "GET",
    url: process.env.VUE_APP_API_URL + "/fitting/fittingswinglist/" + fittingno,
    headers: { Authorization: "Bearer " + token },
  };
  try {
    await axios(options).then((response) => {
      if (response.data.code === 200) {
        result(true, response.data);
      } else {
        result(false, response.data);
      }
    });
  } catch (err) {
    console.error("get_fittingswinglist", err);
    result(false, err);
  }
};

// 피팅 스윙 리스트
const get_fittingswingview = async (fittingno, fit_binary_pk, result) => {
  const token = sessionStorage.getItem("token") || null;
  const options = {
    method: "GET",
    url:
      process.env.VUE_APP_API_URL +
      "/fitting/fittingswingview/" +
      fittingno +
      "/" +
      fit_binary_pk,
    headers: { Authorization: "Bearer " + token },
  };
  try {
    await axios(options).then((response) => {
      if (response.data.code === 200) {
        result(true, response.data);
      } else {
        result(false, response.data);
      }
    });
  } catch (err) {
    console.error("get_fittingswingview", err);
    result(false, err);
  }
};

const get_fittinganswerview = async (fitreqno, result) => {
  const options = {
    method: "GET",
    url: process.env.VUE_APP_API_URL + "/fitting/fittinganswerview/" + fitreqno,
    //url: 'http://localhost/test.php',
    //headers: {'Content-Type': 'application/x-www-form-urlencoded'},
  };
  try {
    await axios(options).then((response) => {
      if (response.data.code === 200) {
        result(true, response.data);
      } else {
        result(false, response.data);
      }
    });
  } catch (err) {
    console.error("get_fittinganswerview", err);
    result(false, err);
  }
};

// 판매보기
const get_saleview = async (fit_ans_pk, result) => {
  const token = sessionStorage.getItem("token") || null;
  const options = {
    method: "GET",
    url: process.env.VUE_APP_API_URL + "/fitting/saleview/" + fit_ans_pk,
    headers: { Authorization: "Bearer " + token },
  };
  try {
    await axios(options).then((response) => {
      if (response.data.code === 200) {
        result(true, response.data);
      } else {
        result(false, response.data);
      }
    });
  } catch (err) {
    console.error("get_saleview", err);
    result(false, err);
  }
};

// 피팅내역보기
const get_fitresultview = async (fitreqno, result) => {
  const token = sessionStorage.getItem("token") || null;
  const options = {
    method: "GET",
    url: process.env.VUE_APP_API_URL + "/fitting/fitresultview/" + fitreqno,
    headers: { Authorization: "Bearer " + token },
    //url: 'http://localhost/test.php',
    //headers: {'Content-Type': 'application/x-www-form-urlencoded'},
  };
  try {
    await axios(options).then((response) => {
      if (response.data.code === 200) {
        result(true, response.data);
      } else {
        result(false, response.data);
      }
    });
  } catch (err) {
    console.error("get_fitresultview", err);
    result(false, err);
  }
};

const get_salelist = async (param, result) => {
  const token = sessionStorage.getItem("token") || null;
  const options = {
    method: "GET",
    url: process.env.VUE_APP_API_URL + "/fitting/salelist",
    headers: { Authorization: "Bearer " + token },
    //url: 'http://localhost/test.php',
    //headers: {'Content-Type': 'application/x-www-form-urlencoded'},
    params: {
      searchtype: param.searchtype,
      searchname: param.searchname,
      pageno: param.pageno,
      goodstype: param.goodstype,
      findex: param.findex,
      pagesize: param.pagesize,
      brandno: param.brandno,
    },
  };
  try {
    await axios(options).then((response) => {
      if (response.data.code === 200) {
        result(true, response.data);
      } else {
        result(false, response.data);
      }
    });
  } catch (err) {
    console.error("get_salelist", err);
    result(false, err);
  }
};

const get_custormerlist = async (param, result) => {
  const token = sessionStorage.getItem("token") || null;

  const options = {
    method: "GET",
    url: process.env.VUE_APP_API_URL + "/fitting/custormerlist",
    headers: { Authorization: "Bearer " + token },
    //url: 'http://localhost/test.php',
    //headers: {'Content-Type': 'application/x-www-form-urlencoded'},
    params: {
      searchtype: param.searchtype,
      searchname: param.searchname,
      pageno: param.pageno,
      fit_as_category: param.category,
      findex: param.findex,
      pagesize: param.pagesize,
      brandno: param.brandno,
    },
  };
  try {
    await axios(options).then((response) => {
      if (response.data.code === 200) {
        result(true, response.data);
      } else {
        result(false, response.data);
      }
    });
  } catch (err) {
    console.error("get_custormerlist", err);
    result(false, err);
  }
};

// 고객지원보기
const get_custormerview = async (noticeno, searchdata, result) => {
  const token = sessionStorage.getItem("token") || null;
  const options = {
    method: "GET",
    url: process.env.VUE_APP_API_URL + "/fitting/custormerview/" + noticeno,
    headers: { Authorization: "Bearer " + token },
    params: {
      searchtype: searchdata.searchtype,
      searchname: searchdata.searchname,
      fit_as_category: searchdata.category,
    },
  };
  try {
    await axios(options).then((response) => {
      if (response.data.code === 200) {
        result(true, response.data);
      } else {
        result(false, response.data);
      }
    });
  } catch (err) {
    console.error("get_custormerview", err);
    result(false, err);
  }
};
const post_custormerwrite = async (form, noticeno, result) => {
  const data = new FormData();

  for (let key in form) {
    data.append(key, form[key]);
  }

  const options = {
    method: "POST",
    url: "/fitting/custormerwrite/" + noticeno,
    headers: { "Content-Type": "multipart/form-data" },
    data: data,
  };
  try {
    await axios(options).then((response) => {
      if (response.data.code === 200) {
        result(true, response.data);
      } else {
        console.error(response.data.code, response.data.message);
        result(false, response.data);
      }
    });
  } catch (err) {
    result(false, err, 400);
  }
};

const delete_custormerdelete = async (noticeno, result) => {
  const options = {
    method: "DELETE",
    url: "/postact/custormerdelete/" + noticeno,
  };
  try {
    await axios(options).then((response) => {
      if (response.data.code === 200) {
        result(true, response.data);
      } else {
        console.error(response.data.code, response.data.message);
        result(false, response.data);
      }
    });
  } catch (err) {
    result(false, err, 400);
  }
};

// 브랜드 리스트
const get_brandlist = async (result) => {
  let finalData = {
    code: "",
    message: "",
    searchbrandlist: [],
  };

  const options = {
    method: "GET",
    url: process.env.VUE_APP_API_URL + "/fitting/brandlist",
  };

  try {
    await axios(options).then((response) => {
      if (response.data.code === 200) {
        finalData = _.merge(finalData, response.data);
        result(true, finalData);
      } else {
        console.error(response.data.code, response.data.message);
        result(false, response.data.message);
      }
    });
  } catch (err) {
    console.error("get_brandlist", err);
    result(false, err);
  }
};

export default {
  get_fittinglist,
  get_fittingswinglist,
  get_fittingswingview,
  get_fittinganswerview,
  get_salelist,
  get_saleview,
  get_fitresultview,
  get_custormerlist,
  get_custormerview,
  post_custormerwrite,
  delete_custormerdelete,
  get_brandlist,
};
